export const getPrefixForLocalStorage = function getPrefixForLocalStorage() { /* console.log(this, this.state, this.context) */ }